import { NavigationMessages } from './navigationMessages';

const ERROR_COLOR = 'error';

export const NavigationErrorNotifications = Object.freeze({
	slideDoesNotExists: {
		text: NavigationMessages.slideDoesNotExists,
		color: ERROR_COLOR
	},
	canNotNavigate: {
		text: NavigationMessages.canNotNavigate,
		color: ERROR_COLOR
	}
});